const uuid = require("uuid");
const { create } = require("xmlbuilder2");
const convert = require("xml-js");

import {
  assign,
  filter,
  find,
  forEach,
  get,
  isEmpty,
  isNil,
  isString,
  map,
  some,
} from "lodash";

import commonElements from "src/components/addProject/pou/commonElements.json";
import ldElements from "src/components/addProject/pou/ldElements.json";
import customMx from "./customMx";

export default {
  mixins: [customMx],
  data() {
    return {
      editedCell: {},
      editedObj: {},
      dialogTitle: "",
      dialog: false,
      graph: null,

      connectionTypes: [
        {
          text: "Connector",
          value: "connector",
        },
        { text: "Continuation", value: "continuation" },
      ],
      powerRailTypes: [
        { text: "Left Power Rail", value: "leftPowerRail" },
        { text: "Right Power Rail", value: "rightPowerRail" },
      ],
      contactModifiers: [
        { text: "Normal", value: "normal" },
        { text: "Negated", value: "negated" },
        { text: "Rising Edge", value: "risingEdge" },
        { text: "Falling Edge", value: "fallingEdge" },
      ],
      coilModifiers: [
        { text: "Normal", value: "normal" },
        { text: "Negated", value: "negated" },
        { text: "Set", value: "set" },
        { text: "Reset", value: "reset" },
        { text: "Rising Edge", value: "risingEdge" },
        { text: "Falling Edge", value: "fallingEdge" },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.customMx();
      this.initGraph();
    }, 1000);
  },
  methods: {
    initGraph() {
      const container = document.getElementById("graphContainer");
      const editor = new mxEditor();

      this.graph = editor.graph;
      this.parent = this.graph.getDefaultParent();
      editor.setGraphContainer(container);

      this.graph.setAllowDanglingEdges(false);
      this.graph.convertValueToString = this.convertCellValueToString;
      this.graph.setConnectable(true);

      this.graph.model.addListener(mxEvent.CHANGE, (sender, evt) => {
        this.saveGraph();

        evt.consume();
      });

      this.graph.addListener(mxEvent.DOUBLE_CLICK, (sender, evt) => {
        const cell = evt.getProperty("cell");
        if (cell != null) {
          this.handleDoubleClickOnCell(cell);
        }
        evt.consume();
      });

      this.configureStylesheet();
      this.configureToolBar(editor);
      this.configureSideBar();
      this.renderFromXml(this.graph, this.pou.body.data.text);
    },
    configureStylesheet() {
      const recStyle = {};
      recStyle[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_RECTANGLE;
      recStyle[mxConstants.STYLE_PERIMETER] = mxPerimeter.RectanglePerimeter;
      recStyle[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_CENTER;
      recStyle[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.ALIGN_MIDDLE;
      recStyle[mxConstants.STYLE_STROKECOLOR] = "black";
      recStyle[mxConstants.STYLE_FILLCOLOR] = "white";
      recStyle[mxConstants.STYLE_FONTCOLOR] = "#000000";
      recStyle[mxConstants.STYLE_FONTSIZE] = "12";
      recStyle[mxConstants.STYLE_FONTSTYLE] = 0;
      recStyle[mxConstants.STYLE_IMAGE_WIDTH] = "48";
      recStyle[mxConstants.STYLE_IMAGE_HEIGHT] = "48";
      this.graph.getStylesheet().putDefaultVertexStyle(recStyle);

      const variableLabelStyle = {};
      variableLabelStyle[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_IMAGE;
      variableLabelStyle[mxConstants.STYLE_PERIMETER] =
        mxPerimeter.RectanglePerimeter;
      variableLabelStyle[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_CENTER;
      variableLabelStyle[mxConstants.STYLE_VERTICAL_ALIGN] =
        mxConstants.ALIGN_TOP;
      variableLabelStyle[mxConstants.STYLE_LABEL_POSITION] =
        mxConstants.ALIGN_CENTER;
      variableLabelStyle[mxConstants.STYLE_FILLCOLOR] = "white";
      variableLabelStyle[mxConstants.STYLE_FONTCOLOR] = "#000000";
      variableLabelStyle[mxConstants.STYLE_FONTSIZE] = "12";
      variableLabelStyle[mxConstants.STYLE_FONTSTYLE] = 0;
      this.graph
        .getStylesheet()
        .putCellStyle("variableLabel", variableLabelStyle);

      const executionOrderStyle = {};
      executionOrderStyle[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_IMAGE;
      executionOrderStyle[mxConstants.STYLE_PERIMETER] =
        mxPerimeter.RectanglePerimeter;
      executionOrderStyle[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_RIGHT;
      executionOrderStyle[mxConstants.STYLE_VERTICAL_ALIGN] =
        mxConstants.ALIGN_BOTTOM;
      executionOrderStyle[mxConstants.STYLE_LABEL_POSITION] =
        mxConstants.ALIGN_CENTER;
      executionOrderStyle[mxConstants.STYLE_FILLCOLOR] = "white";
      executionOrderStyle[mxConstants.STYLE_FONTCOLOR] = "#000000";
      executionOrderStyle[mxConstants.STYLE_FONTSIZE] = "12";
      executionOrderStyle[mxConstants.STYLE_FONTSTYLE] = 0;
      this.graph
        .getStylesheet()
        .putCellStyle("executionOrder", executionOrderStyle);

      const jumpTargetStyle = {};
      jumpTargetStyle[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_IMAGE;
      jumpTargetStyle[mxConstants.STYLE_PERIMETER] =
        mxPerimeter.RectanglePerimeter;
      jumpTargetStyle[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_LEFT;
      jumpTargetStyle[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.MIDDLE;
      jumpTargetStyle[mxConstants.STYLE_LABEL_POSITION] =
        mxConstants.ALIGN_CENTER;
      jumpTargetStyle[mxConstants.STYLE_FILLCOLOR] = "white";
      jumpTargetStyle[mxConstants.STYLE_FONTCOLOR] = "#000000";
      jumpTargetStyle[mxConstants.STYLE_FONTSIZE] = "12";
      jumpTargetStyle[mxConstants.STYLE_FONTSTYLE] = 0;
      this.graph.getStylesheet().putCellStyle("jumpTarget", jumpTargetStyle);

      const priorityStyle = {};
      priorityStyle[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_IMAGE;
      priorityStyle[mxConstants.STYLE_PERIMETER] =
        mxPerimeter.RectanglePerimeter;
      priorityStyle[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_RIGHT;
      priorityStyle[mxConstants.STYLE_VERTICAL_ALIGN] =
        mxConstants.ALIGN_BOTTOM;
      priorityStyle[mxConstants.STYLE_LABEL_POSITION] = mxConstants.ALIGN_LEFT;
      priorityStyle[mxConstants.STYLE_FILLCOLOR] = "white";
      priorityStyle[mxConstants.STYLE_FONTCOLOR] = "#000000";
      priorityStyle[mxConstants.STYLE_FONTSIZE] = "12";
      priorityStyle[mxConstants.STYLE_FONTSTYLE] = 0;
      this.graph.getStylesheet().putCellStyle("priority", priorityStyle);

      const transitionLabelStyle = {};
      transitionLabelStyle[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_IMAGE;
      transitionLabelStyle[mxConstants.STYLE_PERIMETER] =
        mxPerimeter.RectanglePerimeter;
      transitionLabelStyle[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_LEFT;
      transitionLabelStyle[mxConstants.STYLE_VERTICAL_ALIGN] =
        mxConstants.ALIGN_CENTER;
      transitionLabelStyle[mxConstants.STYLE_LABEL_POSITION] =
        mxConstants.ALIGN_LEFT;
      transitionLabelStyle[mxConstants.STYLE_VERTICAL_LABEL_POSITION] =
        mxConstants.ALIGN_CENTER;
      transitionLabelStyle[mxConstants.STYLE_FILLCOLOR] = "white";
      transitionLabelStyle[mxConstants.STYLE_FONTCOLOR] = "#000000";
      transitionLabelStyle[mxConstants.STYLE_FONTSIZE] = "12";
      transitionLabelStyle[mxConstants.STYLE_FONTSTYLE] = 0;
      this.graph
        .getStylesheet()
        .putCellStyle("transitionLabel", transitionLabelStyle);

      const edgeStyle = this.graph.getStylesheet().getDefaultEdgeStyle();
      edgeStyle[mxConstants.STYLE_LABEL_BACKGROUNDCOLOR] = "#FFFFFF";
      edgeStyle[mxConstants.STYLE_STROKEWIDTH] = "1";
      edgeStyle[mxConstants.STYLE_STROKECOLOR] = "black";
      edgeStyle[mxConstants.STYLE_ROUNDED] = true;
      edgeStyle[mxConstants.STYLE_EDGE] = mxEdgeStyle.ElbowConnector;
      edgeStyle[mxConstants.STYLE_ENDARROW] = "bidirectional";

      const leftPortStyle = {};
      leftPortStyle[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_LEFT;
      leftPortStyle[mxConstants.STYLE_FONTSIZE] = "8";
      leftPortStyle[mxConstants.STYLE_FONTSTYLE] = 2;
      leftPortStyle[mxConstants.STYLE_LABEL_POSITION] = mxConstants.ALIGN_RIGHT;
      leftPortStyle[mxConstants.STYLE_SHAPE] = "leftPort";
      this.graph.getStylesheet().putCellStyle("leftPort", leftPortStyle);

      const topPortStyle = {};
      topPortStyle[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_CENTER;
      topPortStyle[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.ALIGN_MIDDLE;
      topPortStyle[mxConstants.STYLE_FONTSIZE] = "8";
      topPortStyle[mxConstants.STYLE_FONTSTYLE] = 2;
      topPortStyle[mxConstants.STYLE_SHAPE] = "topPort";
      topPortStyle[mxConstants.STYLE_LABEL_POSITION] = mxConstants.ALIGN_CENTER;
      this.graph.getStylesheet().putCellStyle("topPort", topPortStyle);

      const bottomPortStyle = {};
      bottomPortStyle[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_CENTER;
      bottomPortStyle[mxConstants.STYLE_VERTICAL_ALIGN] =
        mxConstants.ALIGN_MIDDLE;
      bottomPortStyle[mxConstants.STYLE_FONTSIZE] = "8";
      bottomPortStyle[mxConstants.STYLE_FONTSTYLE] = 2;
      bottomPortStyle[mxConstants.STYLE_SHAPE] = "bottomPort";
      bottomPortStyle[mxConstants.STYLE_LABEL_POSITION] =
        mxConstants.ALIGN_CENTER;
      this.graph.getStylesheet().putCellStyle("bottomPort", bottomPortStyle);

      const inPortStyle = {};
      inPortStyle[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_LEFT;
      inPortStyle[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.ALIGN_MIDDLE;
      inPortStyle[mxConstants.STYLE_FONTSIZE] = "8";
      inPortStyle[mxConstants.STYLE_FONTSTYLE] = 2;
      inPortStyle[mxConstants.STYLE_SHAPE] = "inPort";
      inPortStyle[mxConstants.STYLE_LABEL_POSITION] = mxConstants.ALIGN_RIGHT;
      this.graph.getStylesheet().putCellStyle("inPort", inPortStyle);

      const rightPortStyle = {};
      rightPortStyle[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_RIGHT;
      rightPortStyle[mxConstants.STYLE_VERTICAL_ALIGN] =
        mxConstants.ALIGN_MIDDLE;
      rightPortStyle[mxConstants.STYLE_FONTSIZE] = "8";
      rightPortStyle[mxConstants.STYLE_FONTSTYLE] = 2;
      rightPortStyle[mxConstants.STYLE_SHAPE] = "rightPort";
      rightPortStyle[mxConstants.STYLE_LABEL_POSITION] = mxConstants.ALIGN_LEFT;
      this.graph.getStylesheet().putCellStyle("rightPort", rightPortStyle);

      const outPortStyle = {};
      outPortStyle[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_RIGHT;
      outPortStyle[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.ALIGN_MIDDLE;
      outPortStyle[mxConstants.STYLE_FONTSIZE] = "8";
      outPortStyle[mxConstants.STYLE_FONTSTYLE] = 2;
      outPortStyle[mxConstants.STYLE_SHAPE] = "outPort";
      outPortStyle[mxConstants.STYLE_LABEL_POSITION] = mxConstants.ALIGN_LEFT;
      this.graph.getStylesheet().putCellStyle("outPort", outPortStyle);
    },
    configureToolBar(editor) {
      const deleteBtn = document.getElementById("delete-shape-btn");
      mxEvent.addListener(deleteBtn, "click", function(evt) {
        editor.execute("delete");
      });

      const cutBtn = document.getElementById("cut-shape-btn");
      mxEvent.addListener(cutBtn, "click", function(evt) {
        editor.execute("cut");
      });

      const copyBtn = document.getElementById("copy-shape-btn");
      mxEvent.addListener(copyBtn, "click", function(evt) {
        editor.execute("copy");
      });

      const pasteBtn = document.getElementById("paste-shape-btn");
      mxEvent.addListener(pasteBtn, "click", function(evt) {
        editor.execute("paste");
      });

      const undoBtn = document.getElementById("undo-shape-btn");
      mxEvent.addListener(undoBtn, "click", function(evt) {
        editor.execute("undo");
      });

      const redoBtn = document.getElementById("redo-shape-btn");
      mxEvent.addListener(redoBtn, "click", function(evt) {
        editor.execute("redo");
      });
    },
    configureSideBar() {
      this.configureCommonElements();
      this.configureCommonPous();

      if (this.name === "LD") {
        this.configureLdElements();
      } else if (this.name === "SFC") {
        this.configureLdElements();
        this.configureSfcElements();
      }

      this.configureUserDefinedPous();
      this.configureVariables();
    },
    configureCommonElements() {
      for (const commonElement of commonElements) {
        const sidebarItem = document.getElementById(
          `el_${commonElement.elementType}`
        );
        if (!sidebarItem) {
          return;
        }

        const funct = (graph, evt, _, x, y) => {
          const parent = graph.getDefaultParent();
          const model = graph.getModel();
          model.beginUpdate();

          if (commonElement.elementType === "comment") {
            const cell = graph.insertVertex(
              parent,
              null,
              JSON.stringify(commonElement),
              x,
              y,
              200,
              100
            );
            cell.setConnectable(false);
          } else if (commonElement.elementType === "connection") {
            const cell = graph.insertVertex(
              parent,
              null,
              JSON.stringify(commonElement),
              x,
              y,
              100,
              50,
              "shape=connection"
            );
            cell.setConnectable(false);

            this.addPortToConnection(cell, commonElement.type);
          }

          model.endUpdate();
          this.graph.refresh();
        };

        this.makeDragEl(sidebarItem, funct);
      }
    },
    addPortToConnection(cell, type) {
      if (type === "connector") {
        const leftPort = this.graph.insertVertex(
          cell,
          null,
          JSON.stringify({ name: "", style: "leftPort" }),
          0,
          0.5,
          10,
          10,
          "leftPort",
          true
        );

        leftPort.geometry.offset = new mxPoint(-10, -5);
      } else if (type === "continuation") {
        const rightPort = this.graph.insertVertex(
          cell,
          null,
          JSON.stringify({ name: "", style: "rightPort" }),
          1,
          0.5,
          10,
          10,
          "rightPort",
          true
        );

        rightPort.geometry.offset = new mxPoint(0, -5);
      }
    },
    configureCommonPous() {
      for (const pou of this.$store.state.commonPous.standardFunctionBlocks) {
        this.configurePouThatHasType(pou);
      }

      for (const pou of this.$store.state.commonPous.additionalFunctionBlocks) {
        this.configurePouThatHasType(pou);
      }

      for (const pou of this.$store.state.commonPous.typeConversions) {
        this.configurePou(pou);
      }

      for (const pou of this.$store.state.commonPous.numerical) {
        this.configurePou(pou);
      }

      for (const pou of this.$store.state.commonPous.arithmetic) {
        this.configurePou(pou);
      }

      for (const pou of this.$store.state.commonPous.time) {
        this.configurePou(pou);
      }

      for (const pou of this.$store.state.commonPous.bitShift) {
        this.configurePou(pou);
      }

      for (const pou of this.$store.state.commonPous.bitWise) {
        this.configurePou(pou);
      }

      for (const pou of this.$store.state.commonPous.selection) {
        this.configurePou(pou);
      }

      for (const pou of this.$store.state.commonPous.comparision) {
        this.configurePou(pou);
      }

      for (const pou of this.$store.state.commonPous.characterString) {
        this.configurePou(pou);
      }
    },
    configurePouThatHasType(item) {
      const sidebarItem = document.getElementById(`pou_${item.id}`);
      if (!sidebarItem) {
        return;
      }

      const funct = (graph, evt, _, x, y) => {
        const parent = graph.getDefaultParent();
        const model = graph.getModel();

        let cell;

        try {
          model.beginUpdate();

          cell = graph.insertVertex(
            parent,
            null,
            JSON.stringify(item),
            x,
            y,
            120,
            60
          );
          cell.setConnectable(false);

          this.addVariableLabelToPou(cell, item.variableName);
          this.addExecutionOrderToPou(cell, item.executionOrder);
          this.addPortsToPou(cell, item);
        } finally {
          model.endUpdate();
          graph.refresh();

          // this.$store.dispatch("addPouVariable", {
          //   pouTempId: this.pouTempId,
          //   variable: {
          //     tempId: uuid.v4(),
          //     class: "Local",
          //     name: item.variableName,
          //     type: {
          //       name: "derived",
          //       derivedName: item.name,
          //     },
          //   },
          // });
        }

        graph.setSelectionCell(cell);
      };

      this.makeDragEl(sidebarItem, funct);
    },
    addVariableLabelToPou(cell, variableName) {
      if (!isString(variableName)) {
        return;
      }

      const variableLabel = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({
          elementType: "variableName",
          value: variableName,
        }),
        0.5,
        0,
        10,
        15,
        "variableLabel",
        true
      );

      variableLabel.setConnectable(false);
      variableLabel.geometry.offset = new mxPoint(-5, -15);
    },
    configurePou(item) {
      const sidebarItem = document.getElementById(`pou_${item.id}`);
      if (!sidebarItem) {
        return;
      }

      const funct = (graph, evt, _, x, y) => {
        const parent = graph.getDefaultParent();
        const model = graph.getModel();
        let cell = null;

        try {
          model.beginUpdate();

          cell = graph.insertVertex(
            parent,
            null,
            JSON.stringify(item),
            x,
            y,
            120,
            60
          );
          cell.setConnectable(false);
          this.addExecutionOrderToPou(cell, item.executionOrder);
          this.addPortsToPou(cell, item);
        } finally {
          model.endUpdate();
          graph.refresh();

          // this.$store.dispatch("addPouVariable", {
          //   pouTempId: this.pouTempId,
          //   variable: {
          //     tempId: uuid.v4(),
          //     class: "Local",
          //     name: item.variableName,
          //     type: {
          //       name: "derived",
          //       derivedName: item.name,
          //     },
          //   },
          // });
        }

        graph.setSelectionCell(cell);
      };

      this.makeDragEl(sidebarItem, funct);
    },
    addExecutionOrderToPou(cell, order) {
      const executionOrderCell = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({
          elementType: "executionOrder",
          value: order,
        }),
        1,
        1,
        10,
        10,
        "executionOrder",
        true
      );

      executionOrderCell.geometry.offset = new mxPoint(5, 5);
    },
    addPortsToPou(cell, pouItem) {
      const inputLength = pouItem.inputs.length;
      const outputLength = pouItem.outputs.length;

      const inOffset = 1 / (inputLength + 1);
      let currentInPos = inOffset;
      for (const input of pouItem.inputs) {
        const port = this.graph.insertVertex(
          cell,
          null,
          JSON.stringify({
            elementType: "leftPort",
            name: input.name,
          }),
          0,
          currentInPos,
          10,
          10,
          `${input.style}`,
          true
        );

        port.geometry.offset = new mxPoint(-10, -5);
        currentInPos += inOffset;
      }

      const outOffset = 1 / (outputLength + 1);
      let currentOutPos = outOffset;
      for (const output of pouItem.outputs) {
        const port = this.graph.insertVertex(
          cell,
          null,
          JSON.stringify({
            elementType: "rightPort",
            name: output.name,
          }),
          1,
          currentOutPos,
          10,
          10,
          `${output.style}`,
          true
        );

        port.geometry.offset = new mxPoint(0, -5);
        currentOutPos += outOffset;
      }
    },
    configureLdElements() {
      for (const ldElement of ldElements) {
        const sidebarItem = document.getElementById(
          `ldEl_${ldElement.elementType}`
        );
        if (!sidebarItem) {
          return;
        }

        const funct = (graph, evt, _, x, y) => {
          const parent = graph.getDefaultParent();
          const model = graph.getModel();

          let cell = null;

          try {
            model.beginUpdate();

            if (ldElement.elementType === "powerRail") {
              cell = graph.insertVertex(
                parent,
                null,
                JSON.stringify(ldElement),
                x,
                y,
                5,
                90,
                ";fillColor=black"
              );
              cell.setConnectable(false);

              this.addPinToPowerRail(cell, ldElement.pinNumber, ldElement.type);
            } else if (ldElement.elementType === "contact") {
              cell = graph.insertVertex(
                parent,
                null,
                JSON.stringify(ldElement),
                x,
                y,
                50,
                50,
                "shape=normalContact;verticalLabelPosition=top;verticalAlign=bottom"
              );
              cell.setConnectable(false);

              this.addPortToContactCell(cell);
            } else if (ldElement.elementType === "coil") {
              cell = graph.insertVertex(
                parent,
                null,
                JSON.stringify(ldElement),
                x,
                y,
                50,
                50,
                "shape=normalCoil;verticalLabelPosition=top;verticalAlign=bottom"
              );
              cell.setConnectable(false);

              this.addPortToCoilCell(cell);
            }
          } finally {
            model.endUpdate();
            graph.refresh();
          }
        };

        this.makeDragEl(sidebarItem, funct);
      }
    },
    addPinToPowerRail(cell, pinNumber, type) {
      const offset = 1 / (pinNumber + 1);
      let currentPos = offset;
      const inPorts = [];

      try {
        this.graph.getModel().beginUpdate();

        for (let i = 0; i < pinNumber; i += 1) {
          const portType = type === "leftPowerRail" ? "rightPort" : "leftPort";
          const port = this.graph.insertVertex(
            cell,
            null,
            JSON.stringify({
              elementType: portType,
              value: "",
            }),
            type === "leftPowerRail" ? 1 : 0,
            currentPos,
            10,
            10,
            portType,
            true
          );

          if (type === "leftPowerRail") {
            port.geometry.offset = new mxPoint(0, -5);
          } else {
            port.geometry.offset = new mxPoint(-10, -5);
            inPorts.push(port);
          }
          currentPos += offset;
        }
      } finally {
        this.graph.getModel().endUpdate();
        this.graph.refresh();
      }

      return { inPorts };
    },
    configureDivergences(el, x, y, w, h) {
      switch (el.type) {
        case "selectionDivergence": {
          const selectionDivergenceWidth = 50;

          cell = this.graph.insertVertex(
            parent,
            null,
            JSON.stringify(el),
            x,
            y,
            selectionDivergenceWidth,
            1,
            "line;strokeWidth=2"
          );
          cell.setConnectable(false);
          this.addPortToSelectionDivergence(
            cell,
            el.numOfSequences,
            el.portPosition
          );

          break;
        }

        case "selectionConvergence": {
          const selectionDivergenceWidth = 50;

          cell = this.graph.insertVertex(
            parent,
            null,
            JSON.stringify(el),
            x,
            y,
            selectionDivergenceWidth,
            1,
            "line;strokeWidth=2"
          );
          cell.setConnectable(false);
          this.addPortToSelectionDivergence(
            cell,
            el.numOfSequences,
            el.portPosition
          );

          break;
        }
      }
    },
    configureUserDefinedPous() {
      const userDefinedPous = map(this.$store.state.pous, (userDefinedPou) => ({
        elementType: "userDefinedPou",
        name: userDefinedPou.name,
        id: userDefinedPou.name,
        inputs: map(
          filter(userDefinedPou.variables, { class: "Input" }),
          ({ name }) => ({ name, style: "leftPort" })
        ),
        outputs: map(
          filter(userDefinedPou.variables, { class: "Output" }),
          ({ name }) => ({ name, style: "rightPort" })
        ),
      }));

      for (const pou of userDefinedPous) {
        this.configurePou(pou);
      }
    },
    configureVariables() {
      const { variables: pouVariables } = find(this.$store.state.pous, {
        tempId: this.pouTempId,
      });
      const excludedPouVars = filter(
        pouVariables,
        (variable) =>
          !(
            get(variable, "type.name") === "derived" &&
            map(
              this.$store.state.commonPous.standardFunctionBlocks.concat(
                this.$store.state.commonPous.additionalFunctionBlocks
              ),
              "name"
            ).includes(get(variable, "type.derivedName"))
          )
      );

      const variables = map(excludedPouVars, (variable) => {
        const varClass = ["Input", "InOut", "Local", "External"].includes(
          variable.class
        )
          ? "inVariable"
          : "outVariable";

        return {
          elementType: varClass,
          name: variable.name,
          outputs:
            varClass === "inVariable"
              ? [{ name: "Out", style: "rightPort" }]
              : [],
          inputs:
            varClass === "outVariable"
              ? [{ name: "In", style: "leftPort" }]
              : [],
        };
      });

      for (const variable of variables) {
        this.configureVar(variable);
      }
    },
    configureVar(item) {
      const sidebarItem = document.getElementById(`var_${item.name}`);
      if (!sidebarItem) {
        return;
      }

      const funct = (graph, evt, _, x, y) => {
        const parent = graph.getDefaultParent();
        const model = graph.getModel();
        let cell = null;

        try {
          model.beginUpdate();

          cell = graph.insertVertex(
            parent,
            null,
            JSON.stringify(item),
            x,
            y,
            120,
            60
          );
          cell.setConnectable(false);

          const inputLength = item.inputs.length;
          const outputLength = item.outputs.length;

          const inOffset = 1 / (inputLength + 1);
          let currentInPos = inOffset;
          for (const input of item.inputs) {
            const port = graph.insertVertex(
              cell,
              null,
              input.name,
              0,
              currentInPos,
              10,
              10,
              input.style,
              true
            );

            port.geometry.offset = new mxPoint(-10, -5);
            currentInPos += inOffset;
          }

          const outOffset = 1 / (outputLength + 1);
          let currentOutPos = outOffset;
          for (const output of item.outputs) {
            const port = graph.insertVertex(
              cell,
              null,
              output.name,
              1,
              currentOutPos,
              10,
              10,
              output.style,
              true
            );

            port.geometry.offset = new mxPoint(0, -5);
            currentOutPos += outOffset;
          }
        } finally {
          model.endUpdate();
          graph.refresh();
        }

        graph.setSelectionCell(cell);
      };

      this.makeDragEl(sidebarItem, funct);
    },
    renderFromXml(graph, xml) {
      if (isNil(xml)) {
        return;
      }

      const commonPous = [
        ...this.$store.state.commonPous.standardFunctionBlocks,
        ...this.$store.state.commonPous.additionalFunctionBlocks,
        ...this.$store.state.commonPous.typeConversions,
        ...this.$store.state.commonPous.numerical,
        ...this.$store.state.commonPous.arithmetic,
        ...this.$store.state.commonPous.time,
        ...this.$store.state.commonPous.bitShift,
        ...this.$store.state.commonPous.bitWise,
        ...this.$store.state.commonPous.selection,
        ...this.$store.state.commonPous.comparision,
        ...this.$store.state.commonPous.characterString,
      ]

      const xmlWithRoot = `<${this.name}>${xml}</${this.name}>`;
      var model = graph.getModel();
      const oldIdsToNewIds = {};
      const connections = [];
      var parent = graph.getDefaultParent();
      model.beginUpdate();

      const obj = convert.xml2js(xmlWithRoot, { compact: false, spaces: 2 });
      const elements = obj.elements[0].elements;
      const pouElements = filter(elements, { name: "block" });
      for (const pouElement of pouElements) {
        const positionElement = find(pouElement.elements, {
          name: "position",
        });
        const inputVariableElements = filter(pouElement.elements, {
          name: "inputVariables",
        });
        const outputVariableElements = filter(pouElement.elements, {
          name: "outputVariables",
        });

        const commonPou = find(commonPous, { name: pouElement.attributes.typeName })

        const pouCell = graph.insertVertex(
          parent,
          null,
          JSON.stringify({
            ...commonPou,
            executionOrderId: pouElement.attributes.executionOrderId,
            variableName: pouElement.attributes.instanceName
          }),
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +pouElement.attributes.width,
          +pouElement.attributes.height
        );

        this.addExecutionOrderToPou(pouCell, +pouElement.attributes.executionOrderId)

        if (['standardFunctionBlockPou', 'additionalFunctionBlockPou'].includes(pouElement.attributes.typeName)) {
          this.addVariableLabelToPou(pouCell, pouElement.attributes.instanceName)
        }

        oldIdsToNewIds[pouElement.attributes.localId] = pouCell.id;

        forEach(inputVariableElements, (inputVariableElement, i) => {
          const variableElement = inputVariableElement.elements[0];
          const connectionPointInElement = find(variableElement.elements, {
            name: "connectionPointIn",
          });

          const relPositionElement = find(connectionPointInElement.elements, {
            name: "relPosition",
          });
          const port = graph.insertVertex(
            pouCell,
            null,
            JSON.stringify({
              elementType: "leftPort",
              name: variableElement.attributes.formalParameter,
            }),
            0,
            +relPositionElement.attributes.y / +pouElement.attributes.height,
            16,
            16,
            "leftPort",
            true
          );

          port.geometry.offset = new mxPoint(-6, -8);

          const connectionElement = find(connectionPointInElement.elements, {
            name: "connection",
          });
          if (connectionElement?.attributes?.refLocalId) {
            connections.push({
              // targetId: pouElement.attributes.localId,
              sourceId: connectionElement.attributes.refLocalId,
              targetPortNewId: port.id,
              sourcePortName: connectionElement.attributes?.formalParameter,
              // targetPortIndex: i,
              // targetPortName: inputVariableElement.attributes.formalParameter,
            });
          }
        });

        for (const outputVariableElement of outputVariableElements) {
          const variableElement = outputVariableElement.elements[0];

          const connectionPointOutElement = find(variableElement.elements, {
            name: "connectionPointOut",
          });
          const relPositionElement = find(connectionPointOutElement.elements, {
            name: "relPosition",
          });
          const port = graph.insertVertex(
            pouCell,
            null,
            JSON.stringify({
              elementType: "rightPort",
              name: variableElement.attributes.formalParameter,
            }),
            1,
            +relPositionElement.attributes.y / +pouElement.attributes.height,
            16,
            16,
            "rightPort",
            true
          );

          port.geometry.offset = new mxPoint(-8, -8);

          // const connectionElement = find(connectionPointOutElement.elements, {
          //   name: "connection",
          // });
          // if (connectionElement?.attributes?.refLocalId) {
          //   connections.push({
          //     sourceId: pouElement.attributes.localId,
          //     targetId: connectionElement?.attributes?.refLocalId,
          //     sourcePortName: outputVariableElement.attributes.formalParameter,
          //   });
          // }
        }
      }

      const inputVariableElements = filter(elements, {
        name: "inVariable",
      });
      for (const inputVariableElement of inputVariableElements) {
        const positionElement = find(inputVariableElement.elements, {
          name: "position",
        });
        const expressionElement = find(inputVariableElement.elements, {
          name: "expression",
        });
        const connectionPointOutElements = filter(
          inputVariableElement.elements,
          { name: "connectionPointOut" }
        );
        const variableCell = graph.insertVertex(
          parent,
          null,
          expressionElement.elements[0].text,
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +inputVariableElement.attributes.width,
          +inputVariableElement.attributes.height
        );

        oldIdsToNewIds[inputVariableElement.attributes.localId] =
          variableCell.id;

        for (const connectionPointOutElement of connectionPointOutElements) {
          // const relPositionElement = find(connectionPointOutElement.elements, {
          //   name: "relPosition",
          // });
          const port = graph.insertVertex(
            variableCell,
            null,
            "Out",
            1,
            0.5,
            16,
            16,
            "port",
            true
          );

          port.geometry.offset = new mxPoint(-8, -8);

          const connectionElement = find(connectionPointOutElement.elements, {
            name: "connection",
          });
          // connections.push({
          //   sourceId: inputVariableElement.attributes.localId,
          //   targetId: connectionElement?.attributes?.refLocalId,
          //   sourcePortName: "Out",
          // });
        }
      }

      const outputVariableElements = filter(elements, {
        name: "outVariable",
      });
      for (const outputVariableElement of outputVariableElements) {
        const positionElement = find(outputVariableElement.elements, {
          name: "position",
        });
        const expressionElement = find(outputVariableElement.elements, {
          name: "expression",
        });
        const connectionPointInElements = filter(
          outputVariableElement.elements,
          { name: "connectionPointIn" }
        );

        const variableCell = graph.insertVertex(
          parent,
          null,
          expressionElement.elements[0].text,
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +outputVariableElement.attributes.width,
          +outputVariableElement.attributes.height
        );

        oldIdsToNewIds[outputVariableElement.attributes.localId] =
          variableCell.id;

        for (const connectionPointInElement of connectionPointInElements) {
          // const relPositionElement = find(connectionPointInElement.elements, {
          //   name: "relPosition",
          // });
          const port = graph.insertVertex(
            variableCell,
            null,
            "In",
            0,
            0.5,
            16,
            16,
            "port",
            true
          );

          port.geometry.offset = new mxPoint(-6, -8);

          const connectionElement = find(connectionPointInElement.elements, {
            name: "connection",
          });
          if (connectionElement?.attributes?.refLocalId) {
            connections.push({
              targetId: outputVariableElement.attributes.localId,
              sourceId: connectionElement.attributes.refLocalId,
              formalParameter: connectionElement.attributes.formalParameter,
              // targetPortName: "In",
            });
          }
        }
      }

      if (this.name !== "FBD") {
        this.renderPowerRailFromXml(elements, oldIdsToNewIds, connections);
        this.renderCoilFromXml(elements, oldIdsToNewIds, connections);
        this.renderContactFromXml(elements, oldIdsToNewIds, connections);
      }

      if (this.name === "SFC") {
        const stepElements = filter(elements, { name: "step" });
        for (const stepElement of stepElements) {
          this.steps.push(stepElement.attributes.name);

          const positionElement = find(stepElement.elements, {
            name: "position",
          });

          const connectors = this.getStepConnectorsFromXmlObj(
            stepElement.elements
          );
          const cell = graph.insertVertex(
            parent,
            null,
            JSON.stringify({
              elementType:
                stepElement.attributes.initialStep === "true"
                  ? "initialStep"
                  : "step",
              name: stepElement.attributes.name,
              connectors,
            }),
            +positionElement.attributes.x,
            +positionElement.attributes.y,
            +stepElement.attributes.width,
            +stepElement.attributes.height,
            stepElement.attributes.initialStep === "true"
              ? `shape=initialStep`
              : null
          );

          oldIdsToNewIds[stepElement.attributes.localId] = cell.id;

          cell.setConnectable(false);
          const { inPort } = this.addConnectorToStep(cell, connectors);

          const connectionPointInElement = find(stepElement.elements, {
            name: "connectionPointIn",
          });

          if (connectionPointInElement) {
            const connectionElement = find(connectionPointInElement.elements, {
              name: "connection",
            });
            if (connectionElement?.attributes?.refLocalId) {
              connections.push({
                // targetId: stepElement.attributes.localId,
                sourceId: connectionElement.attributes.refLocalId,

                targetPortNewId: inPort.id,

                sourcePortName: connectionElement.attributes.formalParameter,
                sourcePortElementType: "bottomPort",
              });
            }
          }
        }

        this.renderTransitions(elements, oldIdsToNewIds, connections);
        this.renderDivergences(elements, oldIdsToNewIds, connections);
        this.renderActions(elements, oldIdsToNewIds, connections);
        this.renderJumps(elements, oldIdsToNewIds, connections);
      }
      // const activeConnections = filter(
      //   connections,
      //   (connection) =>
      //     !isNil(connection.targetId) && !isNil(connection.sourceId)
      // );

      // const sourceConnections = filter(
      //   activeConnections,
      //   ({ sourcePortName }) => !isNil(sourcePortName)
      // );
      // console.log({ sourceConnections });
      // const oldConnections = map(sourceConnections, (sourceConnection) => {
      //   const targetConnection = find(
      //     activeConnections,
      //     (connection) =>
      //       connection.sourceId === sourceConnection.sourceId &&
      //       connection.targetId === sourceConnection.targetId &&
      //       !isNil(connection.targetPortName)
      //   );

      //   return {
      //     ...sourceConnection,
      //     targetPortName: targetConnection.targetPortName,
      //   };
      // });

      const newConnections = map(connections, (connection) => ({
        ...connection,
        sourceId: oldIdsToNewIds[connection.sourceId],
        // targetId: oldIdsToNewIds[connection.targetId],
      }));
      model.endUpdate();

      const cells = graph.getModel().cells;
      model.beginUpdate();

      for (const connection of newConnections) {
        const sourceCell = find(
          cells,
          (cell) => cell.id === connection.sourceId
        );
        // const targetCell = find(cells, cell => cell.id === connection.targetId)

        const sourcePorts = filter(
          this.graph.getChildCells(sourceCell),
          (childCell) => this.isPortCell(childCell)
        );
        let sourcePort;
        if (connection.sourcePortName) {
          sourcePort = find(
            sourcePorts,
            (sourcePort) =>
              JSON.parse(sourcePort.value).name === connection.sourcePortName
          );
        } else if (connection.sourcePortElementType) {
          sourcePort = filter(
            sourcePorts,
            (sourcePort) =>
              JSON.parse(sourcePort.value).elementType ===
              connection.sourcePortElementType
          )[0];
        } else {
          const rightPort = find(sourcePorts, (sourcePort) =>
            this.hasElementType(sourcePort.value, "rightPort")
          );
          if (rightPort) {
            sourcePort = rightPort;
          }

          const bottomPort = find(sourcePorts, (sourcePort) =>
            this.hasElementType(sourcePort.value, "bottomPort")
          );
          if (bottomPort) {
            sourcePort = bottomPort;
          }
        }

        const targetPort = find(
          cells,
          (cell) => cell.id === connection.targetPortNewId
        );
        // const targetPorts = filter(this.graph.getChildCells(targetCell), childCell => this.isPortCell(childCell))
        // const targetPort = targetPorts[connection.targetPortIndex || 0]

        // const sourcePort = find(
        //   cells,
        //   (cell) =>
        //     cell.parent?.id === connection.sourceId &&
        //     cell.value === connection.sourcePortName
        // );

        // const targetPort = find(
        //   cells,
        //   (cell) =>
        //     cell.parent?.id === connection.targetId &&
        //     cell.value === connection.targetPortName
        // );

        if (sourcePort && targetPort) {
          graph.insertEdge(parent, null, "", sourcePort, targetPort);
        }
      }

      model.endUpdate();
    },
    getStepConnectorsFromXmlObj(elements) {
      const connectors = [];

      if (some(elements, (element) => element.name === "connectionPointIn")) {
        connectors.push("input");
      }

      if (some(elements, (element) => element.name === "connectionPointOut")) {
        connectors.push("output");
      }

      if (
        some(elements, (element) => element.name === "connectionPointOutAction")
      ) {
        connectors.push("action");
      }

      return connectors;
    },

    saveCell() {
      switch (this.editedObj.elementType) {
        case "powerRail": {
          this.graph.removeCells(this.graph.getChildCells(this.editedCell));
          this.addPinToPowerRail(
            this.editedCell,
            this.editedObj.pinNumber,
            this.editedObj.type
          );
          this.graph.model.setValue(
            this.editedCell,
            JSON.stringify(this.editedObj)
          );
          break;
        }
        case "contact": {
          this.graph.setCellStyles(
            "shape",
            `${this.editedObj.modifier}Contact`
          );
          this.graph.model.setValue(
            this.editedCell,
            JSON.stringify(this.editedObj)
          );
          break;
        }
        case "coil": {
          this.graph.setCellStyles("shape", `${this.editedObj.modifier}Coil`);
          this.graph.model.setValue(
            this.editedCell,
            JSON.stringify(this.editedObj)
          );
          break;
        }
        case "initialStep":
        case "step": {
          this.graph.removeCells(this.graph.getChildCells(this.editedCell));
          this.addConnectorToStep(this.editedCell, this.editedObj.connectors);
          this.graph.model.setValue(
            this.editedCell,
            JSON.stringify(this.editedObj)
          );
          break;
        }
        case "transition": {
          const childCells = this.graph.getChildCells(this.editedCell);

          const priorityCell = find(childCells, (cell) =>
            this.hasElementType(cell.value, "priority")
          );
          this.graph.model.setValue(
            priorityCell,
            JSON.stringify({
              elementType: "priority",
              value: this.editedObj.priority,
            })
          );

          const labelCell = find(childCells, (cell) =>
            this.hasElementType(cell.value, "transitionLabel")
          );
          this.graph.model.setValue(
            labelCell,
            JSON.stringify({
              elementType: "transitionLabel",
              value:
                this.editedObj.type === "inline" ? this.editedObj.inline : "",
            })
          );

          if (this.editedObj.type === "connection") {
            const connectionCell = find(
              childCells,
              (cell) => cell.style === "shape=leftPort"
            );
            if (!connectionCell) {
              this.addLeftPortToTransition(this.editedCell);
            }
          } else {
            const connectionCell = find(
              childCells,
              (cell) => cell.style === "shape=leftPort"
            );
            if (connectionCell) this.graph.removeCells([connectionCell]);
          }

          this.graph.model.setValue(
            this.editedCell,
            JSON.stringify(this.editedObj)
          );
          break;
        }
        case "jump": {
          const childCells = this.graph.getChildCells(this.editedCell);
          const jumpTargetCell = find(childCells, (cell) =>
            this.hasElementType(cell.value, "jumpTarget")
          );
          this.graph.model.setValue(
            jumpTargetCell,
            JSON.stringify({
              elementType: "jumpTarget",
              value: this.editedObj.target,
            })
          );

          this.graph.model.setValue(
            this.editedCell,
            JSON.stringify(this.editedObj)
          );

          break;
        }
        case "divergence": {
          this.graph.removeCells(this.graph.getChildCells(this.editedCell));

          switch (this.editedObj.type) {
            case "selectionDivergence": {
              this.editedCell.setStyle("shape=line");

              this.addPortToSelectionDivergence(
                this.editedCell,
                this.editedObj.numOfSequences,
                this.editedObj.portPosition
              );
              break;
            }
            case "selectionConvergence": {
              this.editedCell.setStyle("shape=line");

              this.addPortToSelectionConvergence(
                this.editedCell,
                this.editedObj.numOfSequences,
                this.editedObj.portPosition
              );
              break;
            }
            case "simultaneousDivergence": {
              this.editedCell.setStyle("shape=simultaneousDivergence");

              this.addPortToSimultaneousDivergence(
                this.editedCell,
                this.editedObj.numOfSequences,
                this.editedObj.portPosition
              );
              break;
            }
            case "simultaneousConvergence": {
              this.editedCell.setStyle("shape=simultaneousDivergence");

              this.addPortToSimultaneousConvergence(
                this.editedCell,
                this.editedObj.numOfSequences,
                this.editedObj.portPosition
              );
              break;
            }
          }

          this.graph.model.setValue(
            this.editedCell,
            JSON.stringify(this.editedObj)
          );

          break;
        }
        case "action": {
          this.graph.model.setValue(
            this.editedCell,
            JSON.stringify(this.editedObj)
          );

          break;
        }
        case "comment": {
          this.graph.model.setValue(
            this.editedCell,
            JSON.stringify(this.editedObj)
          );
          break;
        }
        case "connection": {
          this.graph.removeCells(this.graph.getChildCells(this.editedCell));
          this.addPortToConnection(this.editedCell, this.editedObj.type);
          this.graph.model.setValue(
            this.editedCell,
            JSON.stringify(this.editedObj)
          );
          break;
        }
        case "userDefinedPou": {
          const childCells = this.graph.getChildCells(this.editedCell);
          const executionOrderCell = find(childCells, (childCell) =>
            this.isJSONString(childCell)
          );

          if (executionOrderCell) {
            this.graph.removeCells([executionOrderCell]);
          }

          this.addExecutionOrderToPou(
            this.editedCell,
            this.editedObj.executionOrder
          );

          this.graph.model.setValue(
            this.editedCell,
            JSON.stringify(this.editedObj)
          );
          break;
        }
        case "standardFunctionBlockPou":
        case "additionalFunctionBlockPou": {
          const childCells = this.graph.getChildCells(this.editedCell);

          const variableLabelCell = find(childCells, (childCell) =>
            this.hasElementType(childCell.value, "variableName")
          );

          this.graph.model.setValue(
            variableLabelCell,
            JSON.stringify({
              elementType: "variableName",
              value: this.editedObj.variableName,
            })
          );

          const executionOrderCell = find(childCells, (childCell) =>
            this.hasElementType(childCell.value, "executionOrder")
          );
          if (executionOrderCell) {
            this.graph.model.setValue(
              executionOrderCell,
              JSON.stringify({
                elementType: "executionOrder",
                value: this.editedObj.executionOrder,
              })
            );
          }

          this.graph.model.setValue(
            this.editedCell,
            JSON.stringify(this.editedObj)
          );

          break;
        }
        case "typeConversionPou":
        case "numericalPou":
        case "arithmeticPou":
        case "timePou":
        case "bitShiftPou":
        case "bitWisePou":
        case "selectionPou":
        case "comparisionPou":
        case "characterStringPou": {
          const childCells = this.graph.getChildCells(this.editedCell);

          const executionOrderCell = find(childCells, (childCell) =>
            this.hasElementType(childCell.value, "executionOrder")
          );
          if (executionOrderCell) {
            this.graph.model.setValue(
              executionOrderCell,
              JSON.stringify({
                elementType: "executionOrder",
                value: this.editedObj.executionOrder,
              })
            );
          }

          this.graph.model.setValue(
            this.editedCell,
            JSON.stringify(this.editedObj)
          );

          break;
        }
      }

      this.graph.refresh();

      this.dialogTitlte = "";
      this.dialog = false;
      this.editedObj = {};
      this.editedCell = null;
    },
    saveGraph() {
      const cells = this.graph.getModel().cells;

      const commentCells = filter(
        cells,
        (cell) =>
          this.isJSONString(cell.value) &&
          JSON.parse(cell.value).elementType === "comment"
      );

      const connectionCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "connection")
      );

      const userDefinedPouCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "userDefinedPou")
      );

      const stdFunctionBlockCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "standardFunctionBlockPou")
      );

      const additionalFunctionBlockCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "additionalFunctionBlockPou")
      );

      const typeConversionCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "typeConversionPou")
      );

      const numericalCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "numericalPou")
      );

      const arithmeticCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "arithmeticPou")
      );

      const timeCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "timePou")
      );

      const bitShiftCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "bitShiftPou")
      );

      const bitWiseCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "bitWisePou")
      );

      const selectionCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "selectionPou")
      );

      const comparisionCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "comparisionPou")
      );

      const characterStringCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "characterStringPou")
      );

      const pouCells = [
        ...userDefinedPouCells,
        ...stdFunctionBlockCells,
        ...additionalFunctionBlockCells,
        ...typeConversionCells,
        ...numericalCells,
        ...arithmeticCells,
        ...timeCells,
        ...bitShiftCells,
        ...bitWiseCells,
        ...selectionCells,
        ...comparisionCells,
        ...characterStringCells,
      ];

      const edgeCells = filter(cells, { edge: true });

      const inputVariableCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "inVariable")
      );
      const outputVariableCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "outVariable")
      );

      const obj = {
        comment: map(commentCells, (commentCell) => {
          return {
            "@localId": commentCell.id,
            "@height": commentCell.geometry.height,
            "@width": commentCell.geometry.width,
            position: {
              "@x": commentCell.geometry.x,
              "@y": commentCell.geometry.y,
            },
            content: {
              "xhtml:p": {
                $: JSON.parse(commentCell.value).value,
              },
            },
          };
        }),
        connector: map(connectionCells, (connectionCell) => {
          const cellValue = JSON.parse(connectionCell.value);

          let connectionPointIn;
          let connectionPointOut;
          const portCell = this.graph.getChildCells(connectionCell)[0];

          if (portCell) {
            if (cellValue.type === "connector") {
              const { cell: sourceCell, port: sourcePort } = this.findSource(
                cells,
                edgeCells,
                portCell.id
              );
              const relPosition = {
                "@x": 0,
                "@y": connectionCell.geometry.height / 2,
              };

              if (sourceCell) {
                connectionPointIn = {
                  connection: {
                    "@refLocalId": sourceCell.id,
                    "@formalParamater": JSON.parse(sourcePort.value).name,
                  },
                  relPosition,
                };
              } else {
                connectionPointIn = {
                  relPosition,
                };
              }
            } else if (cellValue.type === "continuation") {
              connectionPointOut = {
                relPosition: {
                  "@x": connectionCell.geometry.width,
                  "@y": connectionCell.geometry.height / 2,
                },
              };
            }
          }

          return {
            "@name": cellValue.name,
            "@localId": connectionCell.id,
            "@height": connectionCell.geometry.height,
            "@width": connectionCell.geometry.width,
            position: {
              "@x": connectionCell.geometry.x,
              "@y": connectionCell.geometry.y,
            },
            connectionPointIn,
            connectionPointOut,
          };
        }),
        inVariable: map(inputVariableCells, (inputVariableCell) => {
          const outputPortCell = find(
            cells,
            (cell) =>
              cell.style === "port" &&
              cell.geometry.x === 1 &&
              cell.parent.id === inputVariableCell.id
          );

          return {
            "@localId": inputVariableCell.id,
            "@executionOrderId": 0,
            "@width": inputVariableCell.geometry.width,
            "@height": inputVariableCell.geometry.height,
            "@negated": false,
            expression: inputVariableCell.value,
            position: {
              "@x": inputVariableCell.geometry.x,
              "@y": inputVariableCell.geometry.y,
            },
            connectionPointOut: {
              relPosition: {
                "@x": outputPortCell?.geometry?.x,
                "@y": outputPortCell?.geometry?.y,
              },
            },
          };
        }),
        outVariable: map(outputVariableCells, (outputVariableCell) => {
          const inputPort = find(
            cells,
            (cell) =>
              cell.style === "port" &&
              cell.geometry.x === 0 &&
              cell.parent.id === outputVariableCell.id
          );

          const { cell: sourceCell, port: sourcePort } = this.findSource(
            cells,
            edgeCells,
            inputPort?.id
          );

          return {
            "@localId": outputVariableCell.id,
            "@executionOrderId": 0,
            "@width": outputVariableCell.geometry.width,
            "@height": outputVariableCell.geometry.height,
            "@negated": false,
            expression: outputVariableCell.value,
            position: {
              "@x": outputVariableCell.geometry.x,
              "@y": outputVariableCell.geometry.y,
            },
            connectionPointIn: {
              relPosition: {
                "@x": inputPort?.geometry?.x,
                "@y": inputPort?.geometry?.y,
              },
              connection: sourceCell
                ? {
                    "@refLocalId": sourceCell.id,
                    "@formalParameter": JSON.parse(sourcePort.value).name,
                  }
                : undefined,
            },
          };
        }),
        block: map(pouCells, (pouCell) => {
          const pouObj = JSON.parse(pouCell.value);

          const inputPortCells = filter(
            cells,
            (cell) =>
              ["leftPort", "inPort"].includes(cell.style) &&
              cell.parent.id === pouCell.id
          );

          const outputPortCells = filter(
            cells,
            (cell) =>
              ["rightPort", "outPort"].includes(cell.style) &&
              cell.parent.id === pouCell.id
          );

          return {
            "@localId": pouCell.id,
            "@typeName": pouObj.name,
            "@executionOrderId": pouObj.executionOrder,
            "@instanceName": pouObj.variableName,
            "@height": pouCell.geometry.height,
            "@width": pouCell.geometry.width,
            position: {
              "@x": pouCell.geometry.x,
              "@y": pouCell.geometry.y,
            },
            inputVariables: map(inputPortCells, (portCell) => {
              const portObj = JSON.parse(portCell.value);
              const { cell, port } = this.findSource(
                cells,
                edgeCells,
                portCell.id
              );

              return {
                variable: {
                  "@formalParameter": portObj.name,
                  connectionPointIn: {
                    relPosition: {
                      "@x": 0,
                      "@y": pouCell.geometry.height * portCell.geometry.y,
                    },
                    connection: {
                      "@refLocalId": cell?.id,
                      "@formalParameter": port
                        ? JSON.parse(port.value).name
                        : undefined,
                    },
                  },
                },
              };
            }),
            outputVariables: map(outputPortCells, (portCell) => {
              const portObj = JSON.parse(portCell.value);

              return {
                variable: {
                  "@formalParameter": portObj.name,
                  connectionPointOut: {
                    relPosition: {
                      "@x": pouCell.geometry.width,
                      "@y": pouCell.geometry.height * portCell.geometry.y,
                    },
                  },
                },
              };
            }),
            inOutVariables: null,
          };
        }),
      };

      if (this.name === "LD") {
        assign(obj, this.saveLdObjs(cells, edgeCells));
      } else if (this.name === "SFC") {
        assign(obj, this.saveLdObjs(cells, edgeCells));
        assign(obj, this.saveSfcObjs(cells, edgeCells));
      }

      const doc = create({
        [this.name]: obj,
      });
      const xmlText = doc
        .end({ prettyPrint: true, noDoubleEncoding: true })
        .replace('<?xml version="1.0"?>', "")
        .replace(`<${this.name}>`, "")
        .replace(`</${this.name}>`, "");

      this.$store.dispatch("updatePou", {
        ...this.pou,
        body: {
          ...this.pou.body,
          data: {
            text: xmlText,
          },
        },
      });
    },
    saveLdObjs(cells, edgeCells) {
      const leftPowerRailCells = filter(
        cells,
        (cell) =>
          this.hasElementType(cell.value, "powerRail") &&
          JSON.parse(cell.value).type === "leftPowerRail"
      );

      const rightPowerRailCells = filter(
        cells,
        (cell) =>
          this.hasElementType(cell.value, "powerRail") &&
          JSON.parse(cell.value).type === "rightPowerRail"
      );

      const coilCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "coil")
      );

      const contactCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "contact")
      );

      return {
        leftPowerRail: map(leftPowerRailCells, (leftPowerRailCell) => {
          const rightPortCells = filter(
            cells,
            (cell) =>
              cell.style === "rightPort" &&
              cell.parent.id === leftPowerRailCell.id
          );

          return {
            "@localId": leftPowerRailCell.id,
            "@height": leftPowerRailCell.geometry.height,
            "@width": leftPowerRailCell.geometry.width,
            position: {
              "@x": leftPowerRailCell.geometry.x,
              "@y": leftPowerRailCell.geometry.y,
            },
            connectionPointOut: map(rightPortCells, (rightPortCell) => {
              return {
                "@formalParameter": "",
                relPosition: {
                  "@x": leftPowerRailCell.geometry.width,
                  "@y":
                    leftPowerRailCell.geometry.height *
                    rightPortCell.geometry.y,
                },
              };
            }),
          };
        }),

        rightPowerRail: map(rightPowerRailCells, (rightPowerRailCell) => {
          const leftPortCells = filter(
            cells,
            (cell) =>
              cell.style === "leftPort" &&
              cell.parent.id === rightPowerRailCell.id
          );

          return {
            "@localId": rightPowerRailCell.id,
            "@height": rightPowerRailCell.geometry.height,
            "@width": rightPowerRailCell.geometry.width,
            position: {
              "@x": rightPowerRailCell.geometry.x,
              "@y": rightPowerRailCell.geometry.y,
            },
            connectionPointIn: map(leftPortCells, (leftPortCell) => {
              const { cell: sourceCell } = this.findSource(
                cells,
                edgeCells,
                leftPortCell.id
              );

              return {
                "@formalParameter": "",
                relPosition: {
                  "@x": rightPowerRailCell.geometry.width,
                  "@y":
                    rightPowerRailCell.geometry.height *
                    leftPortCell.geometry.y,
                },
                connection: {
                  "@refLocalId": sourceCell?.id,
                },
              };
            }),
          };
        }),

        coil: map(coilCells, (coilCell) => {
          const coilObj = JSON.parse(coilCell.value);

          const leftPortCell = find(
            cells,
            (cell) =>
              cell.style === "leftPort" && cell.parent.id === coilCell.id
          );

          const { cell: sourceCell } = this.findSource(
            cells,
            edgeCells,
            leftPortCell.id
          );

          const rightPortCell = find(
            cells,
            (cell) =>
              cell.style === "rightPort" && cell.parent.id === coilCell.id
          );

          return {
            "@localId": coilCell.id,
            "@height": coilCell.geometry.height,
            "@width": coilCell.geometry.width,
            ...this.calcCoilAttrs(coilObj),
            position: {
              "@x": coilCell.geometry.x,
              "@y": coilCell.geometry.y,
            },
            variable: coilObj.variable,
            connectionPointIn: {
              relPosition: {
                "@x": coilCell.geometry.width,
                "@y": coilCell.geometry.height * leftPortCell.geometry.y,
              },
              connection: {
                "@refLocalId": sourceCell?.id,
              },
            },
            connectionPointOut: {
              relPosition: {
                "@x": coilCell.geometry.width,
                "@y": coilCell.geometry.height * rightPortCell.geometry.y,
              },
            },
          };
        }),

        contact: map(contactCells, (contactCell) => {
          const contactObj = JSON.parse(contactCell.value);

          const leftPortCell = find(
            cells,
            (cell) =>
              cell.style === "leftPort" && cell.parent.id === contactCell.id
          );

          const { cell: sourceCell } = this.findSource(
            cells,
            edgeCells,
            leftPortCell.id
          );

          const rightPortCell = find(
            cells,
            (cell) =>
              cell.style === "rightPort" && cell.parent.id === contactCell.id
          );

          return {
            "@localId": contactCell.id,
            "@height": contactCell.geometry.height,
            "@width": contactCell.geometry.width,
            ...this.calcContactAttrs(contactObj),
            position: {
              "@x": contactCell.geometry.x,
              "@y": contactCell.geometry.y,
            },
            variable: contactObj.variable,
            connectionPointIn: {
              relPosition: {
                "@x": contactCell.geometry.width,
                "@y": contactCell.geometry.height * leftPortCell.geometry.y,
              },
              connection: {
                "@refLocalId": sourceCell?.id,
              },
            },
            connectionPointOut: {
              relPosition: {
                "@x": contactCell.geometry.width,
                "@y": contactCell.geometry.height * rightPortCell.geometry.y,
              },
            },
          };
        }),
      };
    },

    handleDoubleClickOnCell(cell) {
      try {
        this.editedCell = cell;
        this.editedObj = JSON.parse(cell.value);

        switch (this.editedObj.elementType) {
          case "powerRail": {
            this.dialog = true;
            this.dialogTitle = "Power Rail Properties";
            break;
          }
          case "contact": {
            this.dialog = true;
            this.dialogTitle = "Edit Contact Values";
            break;
          }
          case "coil": {
            this.dialog = true;
            this.dialogTitle = "Edit Coil Values";
            break;
          }
          case "initialStep":
          case "step": {
            this.dialog = true;
            this.dialogTitle = "Edit Step";
            break;
          }
          case "transition": {
            this.dialog = true;
            this.dialogTitle = "Edit Transition";
            break;
          }
          case "jump": {
            this.dialog = true;
            this.dialogTitle = "Edit jump target";
            break;
          }
          case "divergence": {
            this.dialog = true;
            this.dialogTitle = "Edit divergence or convergence";
            break;
          }
          case "action": {
            this.dialog = true;
            this.dialogTitle = "Edit action block properties";
            break;
          }
          case "comment": {
            this.dialog = true;
            this.dialogTitle = "Please enter comment text";
            break;
          }
          case "connection": {
            this.dialog = true;
            this.dialogTitle = "Connection Properties";
            break;
          }
          case "standardFunctionBlockPou": {
            this.dialog = true;
            this.dialogTitle = "Block Properties";
            break;
          }
          case "additionalFunctionBlockPou": {
            this.dialog = true;
            this.dialogTitle = "Block Properties";
            break;
          }
          case "userDefinedPou": {
            this.dialog = true;
            this.dialogTitle = "Block Properties";
            break;
          }
          case "typeConversionPou": {
            this.dialog = true;
            this.dialogTitle = "Block Properties";
            break;
          }
          case "numericalPou": {
            this.dialog = true;
            this.dialogTitle = "Block Properties";
            break;
          }
          case "arithmeticPou": {
            this.dialog = true;
            this.dialogTitle = "Block Properties";
            break;
          }
          case "timePou": {
            this.dialog = true;
            this.dialogTitle = "Block Properties";
            break;
          }
          case "bitShiftPou": {
            this.dialog = true;
            this.dialogTitle = "Block Properties";
            break;
          }
          case "bitWisePou": {
            this.dialog = true;
            this.dialogTitle = "Block Properties";
            break;
          }
          case "selectionPou": {
            this.dialog = true;
            this.dialogTitle = "Block Properties";
            break;
          }
          case "comparisionPou": {
            this.dialog = true;
            this.dialogTitle = "Block Properties";
            break;
          }
          case "chracterStringPou": {
            this.dialog = true;
            this.dialogTitle = "Block Properties";
            break;
          }
        }
      } catch (err) {
        // No need to handle
      }
    },
    makeDragEl(sidebarItem, funct) {
      const dragEl = document.createElement("div");
      dragEl.style.border = "dashed black 1px";
      dragEl.style.width = "60px";
      dragEl.style.height = "30px";

      // Creates the image which is used as the drag icon (preview)
      const ds = mxUtils.makeDraggable(
        sidebarItem,
        this.graph,
        funct,
        dragEl,
        0,
        0,
        true,
        true
      );

      ds.setGuidesEnabled(true);
    },
    convertCellValueToString(cell) {
      try {
        const cellObj = JSON.parse(cell.value);

        if (["leftPort", "rightPort", "inPort"].includes(cellObj.elementType)) {
          return cellObj.name;
        }

        if (["contact", "coil"].includes(cellObj.elementType)) {
          return cellObj.variable;
        }

        if (cellObj.elementType === "comment") {
          return cellObj.value;
        }

        if (cellObj.elementType === "connection") {
          return cellObj.name;
        }

        if (cellObj.elementType === "variableName") {
          return cellObj.value;
        }

        if (cellObj.elementType === "executionOrder") {
          if (isNil(cellObj.value) || cellObj.value === 0) {
            return "";
          }

          return cellObj.value.toString();
        }

        if (cellObj.elementType === "jumpTarget") {
          return cellObj.value;
        }

        if (cellObj.elementType === "transitionLabel") {
          return cellObj.value;
        }

        if (cellObj.elementType === "priority") {
          if (+cellObj.value > 0) {
            return cellObj.value.toString();
          }

          return "";
        }

        if (
          [
            "userDefinedPou",
            "standardFunctionBlockPou",
            "additionalFunctionBlockPou",
            "typeConversionPou",
            "numericalPou",
            "arithmeticPou",
            "timePou",
            "bitShiftPou",
            "bitWisePou",
            "selectionPou",
            "comparisionPou",
            "characterStringPou",
            "pou",
            "variable",
            "step",
            "initialStep",
          ].includes(cellObj.elementType)
        ) {
          return cellObj.name;
        }

        if (cellObj.elementType === "action") {
          if (isEmpty(cellObj.actions)) {
            return "";
          }

          const tbl = document.createElement("table");
          tbl.setAttribute("style", "border-collapse: collapse");
          tbl.style.width = `${cell.geometry.width}px`;
          tbl.style.height = `${cell.geometry.height}px`;
          const tbody = document.createElement("tbody");
          for (const action of cellObj.actions) {
            const tr = document.createElement("tr");
            const qualifierTd = document.createElement("td");
            qualifierTd.setAttribute("style", "border: 1px solid");
            qualifierTd.innerText = isNil(action.qualifier)
              ? ""
              : action.qualifier;

            const valueTd = document.createElement("td");
            valueTd.setAttribute("style", "border: 1px solid");
            valueTd.innerText = isNil(action.value) ? "" : action.value;

            const indicatorTd = document.createElement("td");
            indicatorTd.setAttribute("style", "border: 1px solid");
            indicatorTd.innerText = isNil(action.indicator)
              ? ""
              : action.indicator;

            tr.appendChild(qualifierTd);
            tr.appendChild(valueTd);
            tr.appendChild(indicatorTd);

            tbody.appendChild(tr);
          }

          tbl.appendChild(tbody);
          return tbl;
        }

        return "";
      } catch (err) {
        return cell.value;
      }
    },
    hasElementType(cellValue, elementType) {
      return (
        this.isJSONString(cellValue) &&
        JSON.parse(cellValue).elementType === elementType
      );
    },
    findTarget(cells, edges, portId) {
      const edge = find(edges, (edge) => edge.source.id === portId);

      if (!edge) {
        return {};
      }

      const targetPort = find(cells, (cell) => cell.id === edge.target.id);

      return {
        cell: find(cells, (cell) => cell.id === targetPort.parent.id),
        port: targetPort,
      };
    },
    findSource(cells, edges, portId) {
      const edge = find(edges, (edge) => edge.target.id === portId);

      if (!edge) {
        return {};
      }

      const sourcePort = find(cells, (cell) => cell.id === edge.source.id);

      return {
        cell: find(cells, (cell) => cell.id === sourcePort.parent.id),
        port: sourcePort,
      };
    },
    isJSONString(item) {
      if (isNil(item)) {
        return false;
      }

      if (!isString(item)) {
        return false;
      }

      try {
        JSON.parse(item);
        return true;
      } catch (err) {
        return false;
      }
    },
    isPortCell(cell) {
      return (
        this.hasElementType(cell.value, "leftPort") ||
        this.hasElementType(cell.value, "inPort") ||
        this.hasElementType(cell.value, "rightPort") ||
        this.hasElementType(cell.value, "topPort") ||
        this.hasElementType(cell.value, "bottomPort")
      );
    },

    renderPowerRailFromXml(elements, oldIdsToNewIds, connections) {
      this.renderLeftPowerRailFromXml(elements, oldIdsToNewIds, connections);
      this.renderRightPowerRailFromXml(elements, oldIdsToNewIds, connections);
    },
    renderLeftPowerRailFromXml(elements, oldIdsToNewIds, connections) {
      const powerRailElements = filter(elements, { name: "leftPowerRail" });
      for (const powerRailElement of powerRailElements) {
        const positionElement = find(powerRailElement.elements, {
          name: "position",
        });

        const pinNumber = this.getLeftPowerRailPinNumberFromXmlObject(
          powerRailElement.elements
        );

        const cell = this.graph.insertVertex(
          this.parent,
          null,
          JSON.stringify({
            elementType: "powerRail",
            name: "Power rail",
            pinNumber,
            type: "leftPowerRail",
          }),
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +powerRailElement.attributes.width,
          +powerRailElement.attributes.height,
          ";fillColor=black"
        );
        cell.setConnectable(false);

        oldIdsToNewIds[powerRailElement.attributes.localId] = cell.id;

        this.addPinToPowerRail(cell, pinNumber, "leftPowerRail");
      }
    },
    getLeftPowerRailPinNumberFromXmlObject(elements) {
      const connectionPointOutElements = filter(
        elements,
        (element) => element.name === "connectionPointOut"
      );
      return connectionPointOutElements.length;
    },
    renderRightPowerRailFromXml(elements, oldIdsToNewIds, connections) {
      const powerRailElements = filter(elements, { name: "rightPowerRail" });
      for (const powerRailElement of powerRailElements) {
        const positionElement = find(powerRailElement.elements, {
          name: "position",
        });

        const pinNumber = this.getRightPowerRailPinNumberFromXmlObject(
          powerRailElement.elements
        );

        const cell = this.graph.insertVertex(
          this.parent,
          null,
          JSON.stringify({
            elementType: "powerRail",
            name: "Power rail",
            pinNumber,
            type: "rightPowerRail",
          }),
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +powerRailElement.attributes.width,
          +powerRailElement.attributes.height,
          ";fillColor=black"
        );
        cell.setConnectable(false);

        oldIdsToNewIds[powerRailElement.attributes.localId] = cell.id;

        const { inPorts } = this.addPinToPowerRail(
          cell,
          pinNumber,
          "rightPowerRail"
        );

        const connectionPointInElements = filter(powerRailElement.elements, {
          name: "connectionPointIn",
        });
        for (let i = 0; i < connectionPointInElements.length; i += 1) {
          const connectionElement = find(
            connectionPointInElements[i].elements,
            {
              name: "connection",
            }
          );
          if (connectionElement?.attributes?.refLocalId) {
            connections.push({
              sourceId: connectionElement.attributes.refLocalId,

              targetPortNewId: inPorts[i].id,

              sourcePortName: connectionElement.attributes.formalParameter,
            });
          }
        }
      }
    },
    getRightPowerRailPinNumberFromXmlObject(elements) {
      const connectionPointInElements = filter(
        elements,
        (element) => element.name === "connectionPointIn"
      );
      return connectionPointInElements.length;
    },

    addPortToCoilCell(cell) {
      const leftPort = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({ type: "leftPort", value: "" }),
        0,
        0.5,
        10,
        10,
        "leftPort",
        true
      );

      leftPort.geometry.offset = new mxPoint(-10, -5);

      const rightPort = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({ elementType: "rightPort", value: "" }),
        1,
        0.5,
        10,
        10,
        "rightPort",
        true
      );

      rightPort.geometry.offset = new mxPoint(0, -5);

      return { inPort: leftPort };
    },
    renderCoilFromXml(elements, oldIdsToNewIds, connections) {
      const coilElements = filter(elements, { name: "coil" });
      for (const coilElement of coilElements) {
        const negated = coilElement.attributes.negated;
        const edge = coilElement.attributes.edge;

        let modifier;
        if (edge === "rising") {
          modifier = "risingEdge";
        } else if (edge === "falling") {
          modifier = "fallingEdge";
        } else if (negated === "true") {
          modifier = "negated";
        } else {
          modifier = "normal";
        }
        const positionElement = find(coilElement.elements, {
          name: "position",
        });
        const variableElement = find(coilElement.elements, {
          name: "variable",
        });

        const cell = this.graph.insertVertex(
          this.parent,
          null,
          JSON.stringify({
            elementType: "coil",
            name: "coil",
            variable: variableElement.elements[0].text,
            modifier,
          }),
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +coilElement.attributes.width,
          +coilElement.attributes.height,
          `shape=${modifier}Coil;verticalLabelPosition=top;verticalAlign=bottom`
        );
        cell.setConnectable(false);

        oldIdsToNewIds[coilElement.attributes.localId] = cell.id;

        const { inPort } = this.addPortToCoilCell(cell);

        const connectionPointInElement = find(coilElement.elements, {
          name: "connectionPointIn",
        });
        if (connectionPointInElement) {
          const connectionElement = find(connectionPointInElement.elements, {
            name: "connection",
          });
          if (connectionElement?.attributes?.refLocalId) {
            connections.push({
              sourceId: connectionElement.attributes.refLocalId,
              targetPortNewId: inPort.id,
              sourcePortName: connectionElement.attributes.formalParameter,
            });
          }
        }
      }
    },

    addPortToContactCell(cell) {
      const leftPort = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({ elementType: "leftPort", value: "" }),
        0,
        0.5,
        10,
        10,
        "leftPort",
        true
      );

      leftPort.geometry.offset = new mxPoint(-10, -5);

      const rightPort = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({ elementType: "rightPort", value: "" }),
        1,
        0.5,
        10,
        10,
        "rightPort",
        true
      );

      rightPort.geometry.offset = new mxPoint(0, -5);

      return { inPort: leftPort };
    },
    renderContactFromXml(elements, oldIdsToNewIds, connections) {
      const contactElements = filter(elements, { name: "contact" });
      for (const contactElement of contactElements) {
        const negated = contactElement.attributes.negated;
        const edge = contactElement.attributes.edge;

        let modifier;
        if (edge === "rising") {
          modifier = "risingEdge";
        } else if (edge === "falling") {
          modifier = "fallingEdge";
        } else if (negated === "true") {
          modifier = "negated";
        } else {
          modifier = "normal";
        }
        const positionElement = find(contactElement.elements, {
          name: "position",
        });
        const variableElement = find(contactElement.elements, {
          name: "variable",
        });

        const cell = this.graph.insertVertex(
          this.parent,
          null,
          JSON.stringify({
            elementType: "contact",
            name: "Contact",
            variable: variableElement.elements[0].text,
            modifier,
          }),
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +contactElement.attributes.width,
          +contactElement.attributes.height,
          `shape=${modifier}Contact;verticalLabelPosition=top;verticalAlign=bottom`
        );
        cell.setConnectable(false);

        oldIdsToNewIds[contactElement.attributes.localId] = cell.id;

        const { inPort } = this.addPortToContactCell(cell);

        const connectionPointInElement = find(contactElement.elements, {
          name: "connectionPointIn",
        });
        if (connectionPointInElement) {
          const connectionElement = find(connectionPointInElement.elements, {
            name: "connection",
          });
          if (connectionElement?.attributes?.refLocalId) {
            connections.push({
              sourceId: connectionElement.attributes.refLocalId,
              targetPortNewId: inPort.id,
              sourcePortName: connectionElement.attributes.formalParameter,
            });
          }
        }
      }
    },

    calcCoilAttrs(coil) {
      return {
        "@negated": this.calcNegated(coil),
        "@storage": this.calcStorage(coil),
        "@edge": this.calcEdge(coil),
      };
    },
    calcContactAttrs(contact) {
      return {
        "@negated": this.calcNegated(contact),
        "@edge": this.calcEdge(contact),
      };
    },
    calcNegated(coil) {
      if (coil.modifier === "negated") {
        return "true";
      }

      return "false";
    },
    calcStorage(coil) {
      if (coil.modifier === "set") {
        return "set";
      }

      if (coil.modifier === "reset") {
        return "reset";
      }
    },
    calcEdge(coil) {
      if (coil.modifier === "risingEdge") {
        return "rising";
      }

      if (coil.modifier === "fallingEdge") {
        return "falling";
      }
    },
  },
};
